<template>
    <div>
        <div class="flex-grid flex-state-buttons c-claim-header" v-if="current">
            <quantum-icons></quantum-icons>
            <h2 class="u-d-inline-block u-float-l u-margin-right-10">
                <span class="claim-title">{{ humanClaimType }}: </span>{{ pageTitle }}
            </h2>
            <div class="u-d-flex u-position-relative c-claim-header__right">
                <button class="svg_button u-float-l c-icon-tooltip u-r-full-width u-r-d-flex" v-if="!isFinalStep"
                    :class="{'m-icon--disabled' : !current.valid, 'm-icon--save' : current.valid}" @click="saveForm">
                    <svg viewBox="0 0 120 120" class="m-icon m-icon--dark m-icon--small u-d-inline-block" :class="[!current.valid ? 'm-icon--save-hover':'']">
                        <use xlink:href="#save"></use>
                    </svg>
                    <div v-if="tooltipVisible && current.valid || current.valid && theCurrentWidth <= 1024" class="c-icon-tooltip__text c-icon-tooltip__bottom">
                        Save claim progress
                    </div>
                    <div v-if="tooltipVisible && !current.valid || !current.valid && theCurrentWidth <= 1024" class="c-icon-tooltip__text c-icon-tooltip__bottom">
                        Cannot save until all step data is valid
                    </div>
                </button>
                <div v-if="saving()" class="a-loader u-float-l u-d-inline-block a-loader--save-icon"></div>
                <div class="c-claim-header__timeline-text m-hide-timeline" @click="updateTimeline" :class="{ 'm-hide-timeline--closed': isTimelineOpen }"><p>{{timelineText}}</p></div>
            </div>
        </div>
        <div v-show="isTimelineOpen" class="m-timeline">
            <ul v-show="!isDocumentView" class="m-timeline__progress" :class="'m-timeline__progress--' + timelineSteps">
                <router-link v-for="(step, index) in steps"
                             v-if="step.route.meta.step <= 9"
                             tag="li"
                             :to="route(step)"
                             active-class="m-timeline__progress--active"
                             :class="{ 
                                 'm-timeline__progress--active': index <= stepNo && !progressInvalid(index, step),
                                 'm-timeline__progress--disabled': !progressAllowed(index, step), 
                                 'm-timeline__progress--error': progressInvalid(index, step)
                            }">
                    <span>{{ step.name }}</span>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters, mapActions} from 'vuex';
    import {currentHumanClaimType} from 'store/modules/claim';
    import quantumIcons from './Icons.vue';
    import IconTooltip from './IconTooltip.vue';
    import { isStepTransitionAllowed, isStepValid } from 'services/routingMethods';

    export default {
        name: 'timeline',
        props: ['steps','current','stepNo', 'timelineSteps'],
        data: function() {
            return {
                tooltipVisible: false
            }
        },
        components: {
            quantumIcons,
            IconTooltip
        },
        computed: {
            timelineText() {
                return this.isTimelineOpen ? 'Hide Timeline Menu' : 'Show Timeline Menu';
            },
            ...mapGetters('timeline',['isTimelineOpen']),
            ...mapGetters('claim', { claimId: 'id' }),
            ...mapGetters('http', ['running']),
            humanClaimType: {
                get() {
                    return currentHumanClaimType();
                }
            },
            pageTitle: {
                get() {
                    return  'Step ' + (this.stepNo + 1) + ' - ' + this.current.name;
                }
            },
            isDocumentView() {
                let string = this.$route.fullPath.toString();
                let substring = "list";
                return string.includes(substring);
            },
            isFinalStep() {
                let string = this.$route.fullPath.toString();
                let substring = "calculate";
                return string.includes(substring);
            },
            ...mapGetters('windowWidth', ['theCurrentWidth'])
        },
        methods: {
            ...mapActions('timeline', ['updateTimeline']),
            ...mapActions('claim', ['save']),
            ...mapActions('windowWidth', ['updateWidth']),
            /**
             * Is the progress allowed to a step
             * 
             * @param  {int} index (actual index)
             */
            progressAllowed(index, step) {
                // If the index is <= current stepNo, progress must be allowed.
                if (index <= this.stepNo) {
                    return true;
                }

                // Are all the steps up until this index valid. 
                // If they are, progress is allowed.
                return _.range(index).reduce((allValid, index) => {
                    return allValid ? isStepValid(index + 1) : false;
                }, true);
            },
            progressInvalid(index, step) {
                return !step.valid
                    && index === this.stepNo
                    && isStepValid(this.stepNo + 2);
            },
            route(step) {
                let route = step.route;

                if (this.claimId) {
                    route.params = { id : this.claimId };
                }

                return route;
            },
            saveForm() {
                if (!this.current.valid) {
                    return;
                }

                this.save(this.current.step - 1);
            },
            saving() {
                return this.running;
            },
            transitionAllowed(step) {
                if (step == this.current) {
                    return true;
                }

                return step.valid
                    || isStepTransitionAllowed(this.current.route.meta.step, step.route.meta.step);
            }
        },
        mounted() {
            this.updateWidth(window.innerWidth);

            let icon = document.querySelector('.c-icon-tooltip');

            icon.addEventListener('mouseenter', iconEnter);

            let thisScope = this;

            function iconEnter(event) {
                return thisScope.tooltipVisible = true;
            }

            icon.addEventListener('mouseleave', iconLeave);

            function iconLeave(event) {
                return thisScope.tooltipVisible = false;
            }
        }
    }
</script>

<style lang="scss">
    .c-icon-tooltip__text {
        width: 170px;
    }
</style>



// WEBPACK FOOTER //
// Timeline.vue?5821934f